import {getMainViewItemForView} from 'analysis-tool/data-view/AnalysisViewUtils';
import {PipelineGraphQL} from 'pipelines/PipelineTypes';

import {AnalysisMainViewItem, AnalysisMainViewItemType} from './main-view/MainViewTypes';

/**
 * Return default MainViewItem for a given analysis
 *
 * The default is a `AnalysisMainViewItemType.DATA_VIEW` on the first view in the analysis, and if the analysis is empty
 * the default is a `AnalysisMainViewItemType.EMPTY_ANALYSIS`.
 */
export default function getDefaultMainViewItemForAnalysis(analysis: PipelineGraphQL): AnalysisMainViewItem {
  if (analysis.views.length > 0) {
    return getMainViewItemForView(analysis.views[0]);
  }

  return {
    type: AnalysisMainViewItemType.EMPTY_ANALYSIS,
  };
}
